import { render } from "./PedidosConfirmadosVsServidos.vue?vue&type=template&id=7d57a401&scoped=true"
import script from "./PedidosConfirmadosVsServidos.vue?vue&type=script&lang=ts"
export * from "./PedidosConfirmadosVsServidos.vue?vue&type=script&lang=ts"

import "./PedidosConfirmadosVsServidos.vue?vue&type=style&index=0&id=7d57a401&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d57a401"

export default script